import React, {useState} from 'react'
import { useSelector } from 'react-redux'
import useMediaQuery from '@mui/material/useMediaQuery'
import PhotoGrid from './NewAssetComponets/photo-ordering/PhotoGrid'
import usePhotoOrder from './NewAssetComponets/photo-ordering/usePhotoOrder'
import { buildPayload, mediaType, moveTo, placeIn, sameOrder } from './NewAssetComponets/photo-ordering/order'
import { v4 as uuidv4 } from 'uuid';
import useSWRImmutable from 'swr/immutable'
import toast, { Toaster } from "react-hot-toast";
import JSZip from 'jszip'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CircularProgress from '@mui/material/CircularProgress'
import ShareOutlined from '@mui/icons-material/ShareOutlined';
import DownloadIcon from '@mui/icons-material/DownloadOutlined';
import Button from '@mui/material/Button'
import Button4 from '@material-ui/core/Button'
import Collapse from '@mui/material/Collapse'
import Switch from '@material-ui/core/Switch'
import TextField from '@mui/material/TextField'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import Delete from '@mui/icons-material/Delete'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import Display from '../../../../../components/display/Display'
import Feedback from '../../../../../components/feedback/Feedback'
import axios from '../../../../../services/axios'
import { makeStyles } from '@material-ui/core/styles'
import './PropertyPage.scss'

import AssetRow from './NewAssetComponets/AssetRow'
import CommonUploadBox from './NewAssetComponets/CommonUploadBox'
import AssetCard from './NewAssetComponets/AssetCard'
import { useAssets } from './NewAssetComponets/AssetsContext'
import SelectAssetOrigin from './NewAssetComponets/SelectAssetOrigin'

import FullscreenThumbnail from './NewAssetComponets/FullscreenThumbnail'
import handleAssetUploadToS3, { updateAssetsInMobili, publishResources, deleteResource, unpublishResources } from './NewAssetComponets/HandleS3Upload'

import 'moment/locale/es';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100% !important',
		height: '45px !important',
	},
	label: {
		textTransform: 'none',
		fontSize: '18px',
	},
	dark: {
		fontWeight: '700',
		fontSize: '18px !important',
		color: '#f9f9f9',
		border: '0px solid transparent !important',
		backgroundColor: '#3B3B3B !important',
		boxShadow: 'none !important',
		'&:hover': {
			backgroundColor: '#888888',
			color: '#f9f9f9',
			boxShadow: 'none !important',
		},
		'& .MuiButton-iconSizeMedium > *:first-child' : {
			fontSize: '18px !important'
		}
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		// top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
}))


const ModalOriginList = ({ getPropertyID, getMobiliCode, getTitleModal, getOpenModal, setOpenModal, handleList, property_id }) => {
	const classes = useStyles()
	// const [getOrigin, setOrigin] = useState('Captación')
	// const [value, setValue] = React.useState(0)
	const [getLoading, setLoading] = useState(false)


	const closeNow = () => { setOpenModal(false); handleList(); };
	const closing = React.useRef(false);
	const [guard, setGuard] = React.useState(null);
	const [guardBusy, setGuardBusy] = React.useState(false);
	const handleClose = async () => {
		if (closing.current) return;
		closing.current = true;
		try {
			if (!(await ordering.waitForSave())) { showFailedTab(); return; }
			if (ordering.getDirtyTypes().length) setGuard({ label: 'cerrar', action: closeNow });
			else closeNow();
		} finally { closing.current = false; }
	};
	const { updateFileList, files, updateFile, origin, removeAssetFromList } = useAssets();

	const [activeTab,setActiveTab] = React.useState("Fotos")

	/**
	 * @type { 'list' | 'upload' }
	 */
	const [typeOfView, setTypeOfView] = React.useState('list')

	const [ publishedResults, setPublishedResults] = React.useState(false)

	const [selectedResources, setSelectedResources] = React.useState([])

    const desktop = useMediaQuery('(min-width:1200px)');
    const userKey = useSelector(state => state.auth.userData.email || 'anonymous');
    const sizeKey = `mobili.photoGrid.columns.${userKey}`;
    const [columns, setColumns] = React.useState(() => {
        try { const value = Number(localStorage.getItem(sizeKey)); return [3, 4, 5, 6].includes(value) ? value : 6; } catch (_) { return 6; }
    });
    React.useEffect(() => {
        try { const value = Number(localStorage.getItem(sizeKey)); setColumns([3,4,5,6].includes(value) ? value : 6); } catch (_) { setColumns(6); }
    }, [sizeKey]);


	const [tourPath, setTourPath] = React.useState(null);

	const [originAtFilter, setOriginForFilter] = React.useState('none');

	const [date, setDate] = React.useState(Date.now());

	const [collectionDateAtFilter, setCollectionDateAtFilter] = React.useState('none');

	const [bigPicture, setBigPicture] = React.useState({
		open:false,
		url:null,
	});

	const [deleteConfirmation, showDeleteConfirmation] = React.useState(false);

	const [loadingAction,setLoadingAction] = React.useState('none');

	const { data, mutate } = useSWRImmutable(getOpenModal && `dashboard/properties/assets/${getPropertyID}`,(url)=>axios.get(url).then(res => res.data.data));

	const { data:ORIGINS } = useSWRImmutable("dashboard/properties/assets/origins", (url)=>axios.get(url).then(res => res.data.data) )

	const originNumber = (['Captacion', 'Inventario', 'Reparacion', 'Desocupacion'].indexOf(origin) + 1)

	const asset_type = ((["Fotos", "Fotos 360", "Videos", "Tour Virtual"]).indexOf( activeTab ) + 1 )

	const collectionDateValues = React.useMemo( function(){
		const arr = new Set()
		for(const resource of (data ?? [])){
			arr.add(resource.origin_date)
		}
		return Array.from(arr);
	},[data]);

	const ordering = usePhotoOrder(getPropertyID, data, payload => axios.put('dashboard/properties/assets/order', payload), () => mutate());
    const draft = ordering.drafts[asset_type] ?? { working: [], saved: [], stale: false };
    const dirty = !sameOrder(draft.working, draft.saved);
    const actionBusy = ordering.busy || guardBusy || loadingAction !== 'none';
    const blocked = actionBusy || deleteConfirmation;
    function showFailedTab() {
        const type = ordering.getFailedType();
        if (type) { setActiveTab(['Fotos', 'Fotos 360', 'Videos', 'Tour Virtual'][type - 1]); setPublishedResults(true); setSelectedResources([]); }
    }
    const publishedResources = React.useMemo(() => (data ?? []).filter(resource => mediaType(resource) === asset_type && Boolean(Number(resource.published))), [data, asset_type]);
    const resourceMap = new Map((data ?? []).map(resource => [resource.asset_id, resource]));
    const orderList = draft.working.map(id => resourceMap.get(id)).filter(Boolean);
    const sourceList = publishedResults ? orderList : (data ?? []).filter(resource => mediaType(resource) === asset_type && !Number(resource.published));
    const filterData = sourceList.filter(resource =>
        (originAtFilter === 'none' || resource.asset_origin.value === originAtFilter) &&
        (collectionDateAtFilter === 'none' || resource.origin_date === collectionDateAtFilter));
    const filtered = originAtFilter !== 'none' || collectionDateAtFilter !== 'none';
    const clearFilters = () => { setOriginForFilter('none'); setCollectionDateAtFilter('none'); };
    function requestAction(action, label) {
        if (blocked) return;
        if (ordering.getDirtyTypes().length) setGuard({ action, label }); else action();
    }
    async function resolveGuard(save) {
        if (!guard || guardBusy) return;
        const next = guard.action;
        setGuardBusy(true);
        if (save && !(await ordering.saveAll())) { showFailedTab(); setGuardBusy(false); setGuard(null); return; }
        if (!save) ordering.discardAll();
        setGuard(null); setGuardBusy(false); next();
    }
    function selectResource(resource, checked) {
        setSelectedResources(old => checked ? [...old.filter(item => item.asset_id !== resource.asset_id), resource] : old.filter(item => item.asset_id !== resource.asset_id));
    }
    function unpublishAction(resources) {
        setLoadingAction('unpublish');
        unpublishResources({ property_id: getPropertyID, asset_type_id: asset_type, asset_files: resources.map(row => ({ id: row.asset_id })) }, () => {
            toast.success('Cambios hechos!'); setLoadingAction('none'); mutate(); setSelectedResources([]);
        }).catch(() => { setLoadingAction('none'); toast.error('No se pudieron quitar los recursos de publicación'); });
    }
    function publishAction() {
        setLoadingAction('publish');
        const ids = [...publishedResources, ...selectedResources].map(row => row.asset_id);
        publishResources(buildPayload(getPropertyID, asset_type, [...new Set(ids)]), () => {
            toast.success('Publicados correctamente'); setLoadingAction('none'); mutate(); setSelectedResources([]);
        }).catch(() => { setLoadingAction('none'); toast.error('No se pudieron publicar los recursos'); });
    }
    function moveVisible(id, direction) {
        if (blocked) return;
        const visible = filterData.map(row => row.asset_id);
        const from = visible.indexOf(id), to = from + direction;
        if (from < 0 || to < 0 || to >= visible.length) return;
        const arranged = [...visible]; arranged.splice(from, 1); arranged.splice(to, 0, id);
        ordering.change(asset_type, placeIn(draft.working, visible, arranged, id));
    }

	const deleteResourcesAction = (resources = selectedResources)=>{
		setLoadingAction('delete');
		deleteResource({
			asset_files: resources.map(
				(resource)=>{ return { "id":resource.asset_id } }
			)
		}, ()=>{
			setLoadingAction('none');
			toast.success("Recursos borrados!")
			mutate();
			setSelectedResources([]);
		}).catch(e=>{
			setLoadingAction('none');
			toast.error("No se pudo borrar!")
		})
	}

	return (
		<>
			<Dialog
				disableBackdropClick
				disableEscapeKeyDown
				fullWidth={true}
				fullScreen
				maxWidth="xl"
				aria-labelledby="dialogForm"
				open={getOpenModal}
			>
				<DialogTitle id="dialogForm">
					{getTitleModal}

					<IconButton
						onClick={handleClose}
						className="bg-white height-32 width-32"
						classes={{ root: classes.closeButton }}
						aria-label="Cerrar visor de archivos"
					>
						<Display.Icons.CloseIcon
							className="text-dark"
							style={{ fontSize: 20 }}
						/>
					</IconButton>
				</DialogTitle>
				<DialogContent
					className="overflow-hidden"
					dividers
					style={{
						position:'relative', minHeight:0, height:'100%', display:'flex', flexDirection:'column', overflow:'hidden', boxSizing:'border-box',
						margin: "0 auto",
  					maxWidth: "1280px",
  					width: "100%",
						padding:"10px"
					}}

				>
				<Toaster toastOptions={{ position: "bottom-center" }} />
				{ getOpenModal && <FullscreenThumbnail {...bigPicture} onClose={()=>{
					setBigPicture({open:false, url:null})
				}}  />}
				<Collapse in={typeOfView === 'list'}>
					<Stack role="tablist" aria-label="Tipos de recursos" direction="row" gap={2} justifyContent="center" mb={2}>
						{
							["Fotos", "Fotos 360", "Videos", "Tour Virtual"].map(
								function(item,index){
									const active =  activeTab === item;
									return <Box component="button" type="button" role="tab" aria-selected={active} key={index} sx={{ border: 0,
										p:"6px 20px",
										cursor:'pointer',
										borderRadius:'2px',
										transition:'all ease-in-out .2s',
										bgcolor: active ? '#1A237E' : 'transparent',
										...(active && {
											fontWeight:700,
											color:"#fff"
										})
									}}
									onClick={()=>{
											setActiveTab(item)
											setSelectedResources([]);
											setPublishedResults(false);
											// clickSwitch()
										}
									}
									>
										{item}{ordering.dirtyTypes.includes(index + 1) ? ' •' : ''}
									</Box>
								}
							)
						}
					</Stack>
				</Collapse>
				<Box display="grid" gridTemplateColumns={desktop ? "minmax(0, 1fr) 220px" : "minmax(0, 1fr)"} gap={2} sx={{ flex: 1, minHeight: 0, overflow: desktop ? "hidden" : "auto" }}>
					<Box borderRight={desktop ? "1px solid #e4e7ec" : "none"} paddingRight={desktop ? 2 : 0} minWidth={0} sx={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
					{/* // ? MAIN Section */}
				{typeOfView === 'list' && (
					<>
						<Stack direction="row" flexWrap="wrap" alignItems="center" gap={1} justifyContent="space-between">
							<Stack direction="row" gap={1}>
								<Box>
									{selectedResources.length}
								</Box>
								<span>Recursos seleccionados</span>
							</Stack>

								<span>{filtered ? `${filterData.length} de ${sourceList.length}` : sourceList.length} recursos</span>
                                {desktop && <label className="photo-grid-size">Tamaño <input aria-label="Tamaño de las fotos" type="range" min="3" max="6" step="1" value={columns} onChange={event => { const value = Number(event.target.value); setColumns(value); try { localStorage.setItem(sizeKey, String(value)); } catch (_) {} }} /></label>}
                                <FormGroup>
									<FormControlLabel control={<Switch  checked={publishedResults} color='primary' size='small' onChange={(_)=>{
										setPublishedResults((prev)=> !prev)
										setSelectedResources([])
									}} />} label="Recursos Publicados" />
								</FormGroup>
						</Stack>


                            {filtered && <div className="photo-order-status">Filtro activo: ves {filterData.length} de {sourceList.length} recursos. {publishedResults && 'Los números son la posición en la secuencia completa. Al soltar, la foto queda junto a la foto visible que adelantó; las fotos ocultas conservan su orden relativo.'}<button type="button" onClick={clearFilters}>Ver todos los recursos</button></div>}
                            {filterData.length === 0 ? <div className="photo-order-empty">{sourceList.length ? 'Ningún recurso coincide con los filtros.' : `Esta propiedad aún no tiene ${publishedResults ? 'recursos publicados' : 'recursos sin publicar'} de este tipo.`}<br />{sourceList.length ? <Button onClick={clearFilters}>Ver todos los recursos</Button> : <Button disabled={blocked} onClick={() => requestAction(() => setTypeOfView('upload'), 'cargar nuevos recursos')}>Cargar nuevos recursos</Button>}</div> : desktop ?
                                <PhotoGrid key={`${getPropertyID}-${asset_type}-${publishedResults}-${originAtFilter}-${collectionDateAtFilter}`} rows={filterData} order={draft.working} saved={draft.saved} type={asset_type} published={publishedResults} busy={blocked || draft.stale} columns={columns} selected={selectedResources} onChange={ids => ordering.change(asset_type, ids)} onSelect={selectResource} onPreview={url => setBigPicture({ open: true, url })} onDelete={resource => requestAction(() => { setSelectedResources([resource]); showDeleteConfirmation(true); }, 'eliminar este recurso')} onUnpublish={resource => requestAction(() => unpublishAction([resource]), 'despublicar este recurso')} /> :
                                <Box sx={{ overflowY: 'auto', maxHeight: '60vh' }}>{filterData.map((resource, index) => <AssetCard key={resource.asset_id} {...resource} asset_type={asset_type} selected={selectedResources.some(item => item.asset_id === resource.asset_id)} onSelect={checked => selectResource(resource, checked)} localMain={publishedResults && asset_type === 1 && draft.working[0] === resource.asset_id} openFullScreen={url => setBigPicture({ open: true, url })} published={publishedResults} disabled={blocked} position={{ first: index === 0, last: index === filterData.length - 1 }} onMove={direction => moveVisible(resource.asset_id, direction)} />)}</Box>}
</>
				)}
				{typeOfView === 'upload' && (
					<Box>

						<Button startIcon={<ChevronLeft />} onClick={()=>{
								setTypeOfView('list');
								mutate();
								setTourPath(null)
								files.map(
									(asset)=>{
										if(asset.mobiliStatus === 'uploaded'){
											removeAssetFromList(asset.name)
										}
									}
								)
							}}>
							volver al listado
						</Button>

						{/* <pre>
							{JSON.stringify(files.map(file=>`${file.name}, ${file.sizeFormated}`),null,2)}
						</pre> */}

						{files.length === 0 && (
							<Box minHeight="40vh - 150px">
								Los recursos serán listados aquí
							</Box>
						)}

						<Collapse in={files.length > 0 || tourPath?.length >0}>
							<Box my={1}>
								<SelectAssetOrigin />
							</Box>
						</Collapse>


						<AssetRow asset_type={asset_type} />

						<div style={{height:'20px'}} />
						{ asset_type === 4 ? (
							<Box>
								<TextField label="URL del Tour virtual" onChange={(event)=> {{
									setTourPath(event.target.value)
								}}} fullWidth />
							</Box>
						) : (
							<CommonUploadBox asset_type={asset_type} multiple={true} onInputChange={(files)=>{
								// console.log({files});
								updateFileList(files);
							}}/>
						)}

						<Stack justifyContent="flex-end" flexDirection="row" gap={2} mt={2}>
							{/* {JSON.stringify(new Intl.DateTimeFormat('en-US').format(new Date(date)))} */}
						<LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
							<DatePicker
								label="Fecha de recolección"
								value={date}
								onChange={(newValue) => {
									setDate(newValue)
								}}
								maxDate={new Date()}
								renderInput={(params) => (
									<TextField {...params} sx={{ width: '100%', alignSelf:'flex-end' }} size="small" />
								)}
							/>
						</LocalizationProvider>
							<button className='btn-upload mt-5' onClick={()=>
								{
									if(asset_type === 4){
										// tour
										if( tourPath.length === 0 )return;
										const uuid = uuidv4();
										updateAssetsInMobili({
											"property_id":getPropertyID,
											"asset_origin_type_id": originNumber,
											"asset_type_id": asset_type,
											"origin_date":new Intl.DateTimeFormat('en-US').format(new Date(date)),
											"asset_files":[
												{
													name:uuid,
													path: tourPath,
													uuid,
												}
											]
										}, (resp)=>{
											if(resp.mobiliStatus === 'uploaded'){
												setTypeOfView('list')
												mutate();
												setTourPath(null)
											}
										})
										return;
									}
									handleAssetUploadToS3(property_id,files,updateFile, function( asset ){
										// return;
										updateAssetsInMobili({
											name: asset.name,
											"property_id":getPropertyID,
											"asset_origin_type_id": originNumber,
											"asset_type_id": asset_type,
											"origin_date":new Intl.DateTimeFormat('en-US').format(new Date(date)),
											"asset_files": [
												{
													uuid:asset.uuid,
													name: asset.name,
													path: asset.path,
												}
											]
										},updateFile)
									})
								}
								}
							>Subir
							</button>
						</Stack>


					</Box>
				)}
				{typeOfView === 'list' && (
					<>
                    <Dialog open={deleteConfirmation} disableEscapeKeyDown aria-labelledby="delete-photo-title">
                        <DialogTitle id="delete-photo-title">Eliminar recursos seleccionados</DialogTitle>
                        <DialogContent>
                            <p>¿Estás seguro de querer eliminar los recursos seleccionados?</p>
                            <Stack direction="row" gap={2} justifyContent="flex-end">
                                <Button4 disabled={actionBusy} onClick={() => {
                                    if (actionBusy) return;
                                    const resources = [...selectedResources];
                                    showDeleteConfirmation(false);
                                    if (ordering.getDirtyTypes().length) setGuard({ action: () => deleteResourcesAction(resources), label: 'eliminar los recursos seleccionados' });
                                    else deleteResourcesAction(resources);
                                }}>Si</Button4>
                                <Button4 disabled={actionBusy} onClick={() => showDeleteConfirmation(false)}>No</Button4>
                            </Stack>
                        </DialogContent>
                    </Dialog>
                        <div className={`photo-order-status ${ordering.message.startsWith('No se pudo') || draft.stale ? 'error' : ordering.dirtyTypes.length ? 'dirty' : ordering.message.startsWith('Orden guardado') ? 'saved' : ''}`} role="status" aria-live="polite">
                            {draft.stale ? 'La lista de recursos cambió. Tu borrador sigue aquí; descarta y recarga antes de guardar.' : ordering.message || (ordering.dirtyTypes.length ? `Cambios sin guardar en ${ordering.dirtyTypes.map(type => ['Fotos', 'Fotos 360', 'Videos', 'Tour Virtual'][type - 1]).join(', ')}.` : (desktop ? 'Orden guardado. Arrastra una foto o usa ⋮ › Mover a posición para cambiarlo.' : 'Orden guardado. Usa las flechas para cambiar el orden y pulsa Guardar.'))}
                            {ordering.message && ordering.dirtyTypes.length > 0 && <span> · Cambios sin guardar en {ordering.dirtyTypes.map(type => ['Fotos', 'Fotos 360', 'Videos', 'Tour Virtual'][type - 1]).join(', ')}.</span>}
                            {dirty && <span> · {draft.working.filter((id, index) => id !== draft.saved[index]).length} cambios de orden{asset_type === 1 && draft.working[0] !== draft.saved[0] ? ` · Nueva foto principal: ${resourceMap.get(draft.working[0])?.asset.name ?? ''}` : ''}</span>}
                            {(dirty || draft.stale) && <button type="button" disabled={blocked} onClick={() => ordering.discard(asset_type)}>Descartar cambios</button>}
                        </div>
<Box position="sticky" bottom={0} display="flex" justifyContent="flex-end" gap={2} zIndex={2}>

						{selectedResources.length > 0 && (
							<div style={{display:'grid', placeContent:'center'}}>
							<IconButton color='primary' size='small' disabled={loadingAction === 'download'} onClick={async()=>{
									setLoadingAction("download");

									const zip = new JSZip();

									zip.file("leeme.txt", "a folder with photos");
									console.log({selectedResources})

									for await(const resource of selectedResources){
										setLoadingAction("download")
										// resource.asset.full_path
										const transfer = await fetch(`${resource.asset.full_path}?cacheblock=true`, {
											// mode:'no-cors',
											// headers:{
											// 	'Access-Control-Allow-Origin':'*'
											// }
										}).catch(e=>{
											setLoadingAction("none")
										});

										console.log({path:resource.asset.full_path})
										console.log({transfer})

										if(transfer.ok){
											const blob = await transfer.blob();
											console.log(blob)
											zip.file(resource.asset.name, blob);
										}else{
											console.log("error",transfer)
											continue;
										}
									}
									// return;

									zip.generateAsync({type:"blob"}).then(function(content) {
										// see FileSaver.js
										// URL.createObjectURL(content)
										const url = URL.createObjectURL(content);
										console.log({url})
										window.open(url)
										setLoadingAction("none")
										// saveAs(content, "example.zip");
									});

									// setTimeout(()=>setLoadingAction("none"),2000)
							}} >
								{loadingAction === 'download' ? <CircularProgress color='inherit' size="23px"/> : <DownloadIcon/>}
							</IconButton>
							</div>
						)}

						{selectedResources.length > 0 && (
							<Button4 variant='outlined' color='secondary' startIcon={ loadingAction === 'delete' ? <CircularProgress color='error' size="20px"/> : <Delete/> } disabled={blocked} onClick={()=>{
                                requestAction(() => showDeleteConfirmation(true), 'eliminar los recursos seleccionados')
							}} >Eliminar</Button4>
						)}


                            {selectedResources.length > 0 && publishedResults && <Button4 variant="outlined" color="secondary" disabled={blocked} onClick={() => requestAction(() => unpublishAction([...selectedResources]), 'despublicar los recursos seleccionados')}>Quitar</Button4>}
                            {!desktop && publishedResults && asset_type === 1 && selectedResources.length === 1 && <Button4 disabled={blocked} onClick={() => ordering.change(1, moveTo(draft.working, selectedResources[0].asset_id, 1))}>Imagen principal</Button4>}
                            {publishedResults && <button className="btn-upload publish-btn" disabled={blocked || !dirty || draft.stale} onClick={async () => { if (!(await ordering.save(asset_type))) showFailedTab(); }}>{ordering.busy ? 'Guardando…' : ordering.message.startsWith('No se pudo') ? 'Reintentar' : 'Guardar'}</button>}
                            {!publishedResults && selectedResources.length > 0 && <button className="btn-upload publish-btn" disabled={blocked} onClick={() => requestAction(publishAction, 'publicar los recursos seleccionados')}>Publicar</button>}
                            <button className="btn-upload" disabled={blocked} onClick={() => requestAction(() => setTypeOfView('upload'), 'cargar nuevos recursos')}>Cargar nuevos recursos</button>
</Box>
					</>
				)}
				{/* // ? END MAIN Section */}
				</Box>
						<Box sx={{overflowY:"auto", minHeight: 0, padding:"0px 18px"}}>
							{/* <Box>
								<IconButton onClick={()=>{
									history.push(`/owners/inventory/${getMobiliCode}/NO_ALBUM_NAME/NO_ALBUM_ID`)
								}}>
									S
								</IconButton>
							</Box> */}
							<FormControl component="fieldset" disabled={typeOfView != 'list'}>
								<FormLabel component="legend">Origen:</FormLabel>
								<RadioGroup aria-label="origen" name="origin" value={originAtFilter} onChange={(event)=>{
									setOriginForFilter(event.target.value);
								}}>
									<FormControlLabel value="none" control={<Radio color='primary' size='small' />} label="Todos"/>
									{(ORIGINS ?? []).map(origin=> (
										<FormControlLabel key={origin.value} value={origin.value} control={<Radio color='primary' size='small' />} label={origin.value}/>
									))}
								</RadioGroup>
							</FormControl>

							<Box mt={2}>
									{/* <input type="text" value="" id="copyText" hidden /> */}
									<FormControl component="fieldset" disabled={typeOfView != 'list'}>
										<FormLabel component="legend">Fecha recolección:</FormLabel>
										<RadioGroup aria-label="date" name="date" value={collectionDateAtFilter} onChange={(event)=>{
											setCollectionDateAtFilter(event.target.value);
										}}>
											<FormControlLabel value="none" control={<Radio color='primary' size='small' />} label="Todas"/>
											{collectionDateValues.map(collectionDate=> (
												<Stack key={collectionDate} direction="row" gap={.5} alignItems="center">
													<FormControlLabel  value={collectionDate} control={<Radio color='primary' size='small' />} label={collectionDate}/>
													<div style={{ opacity: collectionDateAtFilter == collectionDate ? 1 : .1  }}>
														<IconButton size='small' onClick={()=>{
															// const copyText = document.getElementById("copyText");
															if(filterData.length === 0){
																toast.error("No hay recursos que compartir")
																return;
															}
															const origin = ORIGINS.find( (origin)=>  origin.value == originAtFilter)
															if(!origin){
																toast.error("No se encontró origin");
																return;
															}
															console.log({origin})

															// encrypted_origin_date
															const origin_date = filterData.find( resource =>  resource.origin_date === collectionDate );
															if(!origin_date){
																toast.error("No se encontró fecha de recolección");
																return;
															}
															// debugger;
															// console.log({origin_date})
															let url = new URL(`${process.env.REACT_APP_FINANCAR_URL}/detalle/${getPropertyID}`);
															const other = new URLSearchParams();
															other.append("origin_id" , origin.encrypted_key )
															other.append("origin_date" , origin_date.encrypted_origin_date )
															url.search = other.toString()

															// ** only available with https
															if(window.location.protocol.includes("https")){
																navigator.clipboard.writeText(url.href).then(()=>{
																	toast.success("Copiado a portapapeles!")
																})
															}else {
																window.open(url.href)
															}
														}} disabled={originAtFilter === 'none' && collectionDateAtFilter != collectionDate }>
															<ShareOutlined />
														</IconButton>
													</div>
												</Stack>
											))}
										</RadioGroup>
									</FormControl>
							</Box>

						</Box>
						{/* // ? END GRID Section */}
				</Box>
				</DialogContent>
			</Dialog>
            <Dialog open={Boolean(guard)} disableEscapeKeyDown onClose={() => { if (!guardBusy && !ordering.busy) setGuard(null); }} aria-labelledby="photo-order-guard-title">
                <div className="photo-order-guard"><h3 id="photo-order-guard-title">¿Continuar sin guardar el nuevo orden?</h3><p>Hay cambios sin guardar en {ordering.dirtyTypes.map(type => ['Fotos', 'Fotos 360', 'Videos', 'Tour Virtual'][type - 1]).join(', ')}. Antes de {guard?.label}, guarda los cambios o descártalos para volver al último orden guardado.</p><div className="photo-order-guard-actions"><Button disabled={guardBusy || ordering.busy} onClick={() => setGuard(null)}>Seguir editando</Button><Button color="error" disabled={guardBusy || ordering.busy} onClick={() => resolveGuard(false)}>Descartar y {guard?.label === 'cerrar' ? 'cerrar' : 'continuar'}</Button><Button variant="contained" disabled={guardBusy || ordering.busy} onClick={() => resolveGuard(true)}>{guardBusy ? 'Guardando…' : `Guardar y ${guard?.label === 'cerrar' ? 'cerrar' : 'continuar'}`}</Button></div></div>
            </Dialog>
			<Feedback.DialogLoading
				getLoading={getLoading}
				setLoading={setLoading}
			/>
		</>
	)
}


export default ModalOriginList
